export default __webpack_public_path__ + "static/media/alliedHangersCover.1b830ee9.jpg";